/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TaxesResource } from './';
import {
    TaxesResourceFromJSON,
    TaxesResourceFromJSONTyped,
    TaxesResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerCompanyUpdateTaxesRequest
 */
export interface FreelancerCompanyUpdateTaxesRequest {
    /**
     * 
     * @type {Array<TaxesResource>}
     * @memberof FreelancerCompanyUpdateTaxesRequest
     */
    taxes: Array<TaxesResource>;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerCompanyUpdateTaxesRequest
     */
    applicationDate: Date;
}

/**
 * Check if a given object implements the FreelancerCompanyUpdateTaxesRequest interface.
 */
export function instanceOfFreelancerCompanyUpdateTaxesRequest(value: object): value is FreelancerCompanyUpdateTaxesRequest {
    if (!('taxes' in value) || value['taxes'] === undefined) return false;
    if (!('applicationDate' in value) || value['applicationDate'] === undefined) return false;
    return true;
}

export function FreelancerCompanyUpdateTaxesRequestFromJSON(json: any): FreelancerCompanyUpdateTaxesRequest {
    return FreelancerCompanyUpdateTaxesRequestFromJSONTyped(json, false);
}

export function FreelancerCompanyUpdateTaxesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCompanyUpdateTaxesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'taxes': ((json['taxes'] as Array<any>).map(TaxesResourceFromJSON)),
        'applicationDate': (new Date(json['applicationDate'])),
    };
}

export function FreelancerCompanyUpdateTaxesRequestToJSON(value?: FreelancerCompanyUpdateTaxesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'taxes': ((value['taxes'] as Array<any>).map((v) => TaxesResourceToJSON(v))),
        'applicationDate': ((value['applicationDate']).toISOString().substring(0,10)),
    };
}

